export default class TicketTemplatePreviewModalController {

    constructor($uibModalInstance, $scope, $injector, templateId, templateModel) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.fileSaver = this.injector.get('FileSaver');

        this.templateId = templateId;
        this.templateModel = templateModel;
        this.loadingPreview = true;
        this.rsvpIdToPreview = null;
        this.previewResponse = null;
        this.pdfData = null;

        this.walletSlide = 1;
    }

    handleRsvpSelect(rsvpId) {
        if (!_.isEqual(rsvpId, this.rsvpIdToPreview)) {
            this.rsvpIdToPreview = rsvpId;
            this._loadPreview();
        }
    }

    downloadPreview() {
        if (this.loadingPreview || !this.previewResponse) {
            return;
        }

        const blob = new Blob([this.previewResponse.data], {type: this.previewResponse.headers('content-type')});
        this.fileSaver.saveAs(
            blob,
            'preview.pdf'
        );
    }

    dismiss() {
        this.uibModalInstance.close();
    }

    _loadPreview() {
        if (!this.rsvpIdToPreview) {
            return;
        }

        this.loadingPreview = true;
        this.pdfData = null;
        return this.api
            .post(`tickets/templates/${this.templateId}/preview`, {
                rsvp_id: this.rsvpIdToPreview,
                template: this.templateModel
            }, {
                responseType: "blob"
            })
            .then((response) => {
                this.previewResponse = response;
                const blob = new Blob([this.previewResponse.data], {type: this.previewResponse.headers('content-type')});
                blob.arrayBuffer().then((buffer) => {
                    this.pdfData = buffer;
                    this.loadingPreview = false;
                })
            })
            .catch(e => this.alert.handle(e));
    }
}

TicketTemplatePreviewModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'templateId',
    'templateModel'
]



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/controllers/modals/preview-modal.js